import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Users: [],
};

//internally using immer lib (can create mutable state)
export const usersSlice = createSlice({
  name: "UsersData",
  initialState,
  reducers: {
    updateAllUsers: (state, action) => {
      state.Users = action.payload;
    },
  },
});

// this is for dispatch
export const { updateAllUsers } = usersSlice.actions;

// this is for configureStore
export default usersSlice.reducer;
